module.exports = __webpack_public_path__ + "static/pic04.e4825619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic04.jpg
// module id = 530
// module chunks = 35783957827783